<template>
  <SortSearch default-sort="featured" dimension="FeaturedVectors" />
</template>

<script>
import SortSearch from '@/components/SortSearch';

export default {
  components: {
    SortSearch
  },
  nuxtI18n: {
    paths: {
      en: '/featured-vectors',
      es: '/vectores-destacados',
      pt: '/vetores-em-destaque',
      de: '/featured-vectors'
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>
